import { cn } from "@eduviaos/ui-kit";
import { RoadCheckpointPin } from "../roadmap/svg/RoadCheckpointPin";
import { CheckpointCard } from "./CheckpointCard";
import type { RoadmapStep } from "./types";

function pinState(step: RoadmapStep): "locked" | "available" | "completed" {
  if (step.status === "completed") return "completed";
  if (step.locked || step.status === "locked") return "locked";
  return "available";
}

/**
 * Flat list of the same roadmap. Shown when WebGL is unavailable (older devices,
 * blocked GPU, headless), so the roadmap is never a blank rectangle.
 */
export function RoadmapStepList({
  steps,
  focusStepIndex,
  busyStepId,
  onStepAction,
}: {
  steps: RoadmapStep[];
  focusStepIndex: number;
  busyStepId: string | null;
  onStepAction?: (step: RoadmapStep) => void;
}) {
  let ordinal = 0;

  return (
    <ol className="space-y-3">
      {steps.map((step, index) => {
        if (step.kind === "start" || step.kind === "finish") return null;
        if (step.kind === "checkpoint") ordinal += 1;

        return (
          <li key={step.id} className="flex items-start gap-3">
            {step.kind === "checkpoint" && (
              <RoadCheckpointPin
                number={ordinal}
                state={pinState(step)}
                className={cn("size-9 shrink-0", index === focusStepIndex && "scale-110")}
              />
            )}
            <div className="min-w-0 flex-1">
              <CheckpointCard
                step={step}
                checkpointNumber={ordinal}
                isFocus={index === focusStepIndex}
                busy={busyStepId === step.id}
                onAction={onStepAction}
              />
            </div>
          </li>
        );
      })}
    </ol>
  );
}
